module.exports = __webpack_public_path__ + "img/track one.4774c052.jpeg";